import React, { Component } from 'react'

// Components
import Modal from '../../modal/Modal'
import Button from '../../modal/Button'

class LinKButton extends Component {
    constructor(props){
        super(props)
        this.state = {
            showModal: false,
            href: props.href
        }
    }

    handleClick(e){
        e.stopPropagation()
        this.setState({ showModal: true }, () => {
            this.inputFocused.focus()
        })
    }

    closeAction(e){
        e.stopPropagation()
        this.setState({ showModal: false })
        this.props.closeAction(this.state.href, this.props.index, this.props.assetIndex)
    }

    handleKeyPress(e){
        if(e.key === 'Enter'){
            this.closeAction(e)
        }
    }

    handleInputChange(e){
        this.setState({ href: e.target.value })
    }

    render() {
        const { href } = this.state

        return (
            <div className="toolbar-item" onClick={e => this.handleClick(e)}>
                <span>Link</span>
                {this.state.showModal &&
                    <Modal title={'Update Image Link URL'} buttons={[
                        {
                            type: Button,
                            text: 'Ok',
                            action: this.closeAction.bind(this)
                        }
                    ]}>
                        <label>Link URL</label>
                        <input type="url" value={href} placeholder="Image link url"
                            ref={(input) => { this.inputFocused = input }}
                            onKeyPress={e => this.handleKeyPress(e)}
                            onChange={this.handleInputChange.bind(this)}
                        />
                    </Modal>
                }
            </div>
        )
    }
}

export default LinKButton


// WEBPACK FOOTER //
// ./src/components/utils/image-toolbar/LinkButton.js